export default defineNuxtRouteMiddleware(() => {
  const { isHost } = useAuth()
  if (!isHost.value) {
    throw createError({
      statusCode: HttpStatusCode.NotFound,
    })
  }
})
